import { render } from "./HypertensionSummary.vue?vue&type=template&id=fb0c7bfc"
import script from "./HypertensionSummary.vue?vue&type=script&lang=js"
export * from "./HypertensionSummary.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__